import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Params, Router, UrlTree } from '@angular/router';
import {ApiClientConstant} from '@cureskin/api-client';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';

import { AllocatedRegimen } from '../app-constant-types';

export const regimenProductsDetailGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const connectionService = inject(ConnectionService);
  const experimentService = inject(ExperimentService);
  const { queryParams }: { queryParams: Params } = route;

  if (queryParams?.class !== ApiClientConstant.Regimen.Class.FACE) {
    await experimentService.experimentsLoaded;
    if (!experimentService.rebrandedHairProductDetails) return true;
  }
  const regimens = await connectionService.fetchRegimens(queryParams?.regimenId, false);
  const regimen = regimens.find((each: AllocatedRegimen): boolean => each.class === queryParams?.class);

  if (regimen.active) return true;

  return router.createUrlTree(['user', 'regimen', 'revamp-products'], { queryParams });
};
